// import { SNIPPET_TYPE } from '@repo/types';

// import { TabContent, TabContentProps } from './tab-content';

// export type Tab = {
//   triggerTitle: string;
//   title: string;
//   id: SNIPPET_TYPE;
//   content: React.ComponentType<TabContentProps>;
// };

// export const tabs: Tab[] = [
//   {
//     triggerTitle: 'Facts',
//     title: 'Claimed Facts',
//     id: SNIPPET_TYPE.CLAIMEDFACTS,
//     content: TabContent,
//   },
//   {
//     triggerTitle: 'Opinions',
//     title: 'Opinions',
//     id: SNIPPET_TYPE.OPINIONSTATEMENTS,
//     content: TabContent,
//   },
//   {
//     triggerTitle: 'Claims',
//     title: 'Dubious Claims',
//     id: SNIPPET_TYPE.DUBIOUSCLAIMS,
//     content: TabContent,
//   },
// ];

import { SNIPPET_TYPE } from '@repo/types';

import { TabContent } from './tab-content';

export const tabs = [
  {
    title: 'Claimed Facts',
    id: SNIPPET_TYPE.CLAIMEDFACTS,
    content: TabContent,
  },
  {
    title: 'Opinions',
    id: SNIPPET_TYPE.OPINIONSTATEMENTS,
    content: TabContent,
  },
  {
    title: 'Claims',
    id: SNIPPET_TYPE.DUBIOUSCLAIMS,
    content: TabContent,
  },
];
